import React from "react";
import AltaReembolsos from "./altaReembolsos.cmpt";
import firebase from "firebase";

const bdPilotoF2 = firebase.database().ref("/aperturaGmm");
class Gmm extends React.Component {
	ID_NUEVO_TRAMITE = "altaSeguimiento";
	ID_SEGUIMIENTO = "historialCartas";
	ID_INGRESO_HOSPITALARIO = "ingresoHospitalario";
	ETIQUETAS_TABS = {
		portalPiloto : {
			TITULO_NUEVOTRAMITE: "Ingresar nuevo trámite",
			TITULO_SEGUIMIENTO : "Ver trámites en curso"
		},
		portalProd: {
			TITULO_NUEVOTRAMITE: "Trámites y seguimiento",
			TITULO_SEGUIMIENTO : "Historial de cartas"
		}
	};
	VERSION_PILOTO="portalPiloto";
	VERSION_PROD="portalProd";

	state = {
		mostrarAlta : true,
		mostrarHistorial : false,
		secondMenuTitle: "Trámites y seguimiento",
		arrowOrange: [
			require("../img/arrow-down.svg"),
			require("../img/arrow-up.svg")
		],
		tabActivaStr: this.ID_NUEVO_TRAMITE,
		arrowIndexTabs: 0,
		alta: true,
		historial: false,
		mobileTabs: false,
		cargaUsuariosPilotoCompletada: false,
		versionPortal: this.VERSION_PROD
	}


	seleccionSiniestros = opcion => {
		var estadoTemporal = {
			mostrarAlta : false,
			mostrarHistorial : false,
			tabActivaStr: opcion
		};
		switch (opcion) {
		case this.ID_NUEVO_TRAMITE:
			estadoTemporal.mostrarAlta = true;
			break;
		case this.ID_SEGUIMIENTO:
			estadoTemporal.mostrarHistorial = true;
			break;
		default:
		}
		this.setState(estadoTemporal);
	}

	showMobileTabs = () => {
		var arrowIndexTabs;
		if (this.state.arrowIndexTabs == 1) {
			arrowIndexTabs = 0;
		} else if (this.state.arrowIndexTabs == 0) {
			arrowIndexTabs = 1;
		}

		this.setState({
			"mobileTabs": !this.state.mobileTabs,
			"arrowIndexTabs": arrowIndexTabs,
		});
	}

	componentWillUnmount() {
		try {
			bdPilotoF2.off();
		} catch (ex) {
			console.log("Error cerrando referencia bdPilotoF2")
		}
	}

	getCorreoUsuarioLogueado = () => {
		return localStorage.getItem("correoG")
	}

	componentDidMount() {

		if(this.props.tabActiva && this.props.tabActiva === this.ID_INGRESO_HOSPITALARIO){
			this.setState({
				tabActivaStr : this.ID_INGRESO_HOSPITALARIO,
			});
		}

		this.configurarVersionPortalPilotoEIAF2ONacional(
			this.getCorreoUsuarioLogueado()
		);
	}

	esUsuarioPiloto(emailUsuario, listaUsuariosPiloto) {
		return listaUsuariosPiloto instanceof Array
				? listaUsuariosPiloto.map(email => email.toLowerCase()).includes(emailUsuario.toLowerCase())
				: false;
	}

	configurarVersionPortalPilotoEIAF2ONacional = (emailUsuario) => {
		const estadoPortalDefault = {versionPortal: this.VERSION_PROD
							        ,cargaUsuariosPilotoCompletada: true}
		try {
			bdPilotoF2.once('value', (configPiloto) => {
				try {
					const estaActivoPiloto =  configPiloto.child("pilot").val()
					const estaActivoNacional = configPiloto.child("show").val()
					const usuariosPiloto = configPiloto.child("whitelist").val()

					const versionPortal =
						estaActivoNacional
						|| ( estaActivoPiloto
							 && this.esUsuarioPiloto(emailUsuario
								                    ,usuariosPiloto) )
						? this.VERSION_PILOTO
						: this.VERSION_PROD;

					this.setState({versionPortal: versionPortal
								  ,cargaUsuariosPilotoCompletada: true})
				} catch(ex1) {
					console.log("Error al obtener la configuración de usuarios piloto EIAF2")
					console.log(ex1)
					this.setState(estadoPortalDefault)
				}
			});
		} catch (ex2) {
			console.log("Error al obtener la lista de usuarios piloto EIAF2")
			console.log(ex2)
			this.setState(estadoPortalDefault)
		}
	};

	render() {
		const templateMenus =
		<div>
			<div className="tercer-menu text-center hide-mobile">
				<ul className="clearfix">
					<li>
						<button
							disabled={this.state.mostrarAlta}
							className={this.state.mostrarAlta ? "active" : ""}
							onClick={() => this.seleccionSiniestros(this.ID_NUEVO_TRAMITE)}
						>
								{this.ETIQUETAS_TABS[this.state.versionPortal].TITULO_NUEVOTRAMITE}
						</button>
					</li>
					<li>
						<button
							disabled={this.state.mostrarHistorial}
							className={this.state.mostrarHistorial ? "active" : ""}
							onClick={() => this.seleccionSiniestros(this.ID_SEGUIMIENTO)}
						>
								{this.ETIQUETAS_TABS[this.state.versionPortal].TITULO_SEGUIMIENTO}
						</button>
					</li>
				</ul>
			</div>

			<div className="second-menu text-center show-mobile">
				<div className="second-menu-select-mobile">
					<p onClick={this.showMobileTabs}>{this.state.secondMenuTitle}
						<img src={this.state.arrowOrange[this.state.arrowIndexTabs]}/>
					</p>
					{ this.state.mobileTabs &&
						<ul>
							<li >
								<button
									disabled={this.state.mostrarAlta}
									onClick={() => this.seleccionSiniestros(this.ID_NUEVO_TRAMITE)}
								>{this.ETIQUETAS_TABS[this.state.versionPortal].TITULO_NUEVOTRAMITE}</button>
								<div className={this.state.mostrarAlta ? "active" : ""}></div>
							</li>
							<li>
								<button
									disabled={this.state.mostrarHistorial}
									onClick={() => this.seleccionSiniestros(this.ID_SEGUIMIENTO)}
								>{this.ETIQUETAS_TABS[this.state.versionPortal].TITULO_SEGUIMIENTO}</button>
								<div className={this.state.mostrarHistorial ? "active" : ""}></div>
							</li>
						</ul>
					}
				</div>
			</div>
			<AltaReembolsos tabActiva={this.state.tabActivaStr} valoresHospital={this.props.valoresHospital} versionPortal={this.state.versionPortal} />
		</div>

		return(
			this.state.cargaUsuariosPilotoCompletada ?
				templateMenus
			 	: <h3 style={{'textAlign': 'center', 'padding': '12px'}}></h3>
		);
	}
}
export default Gmm;



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/gmm.cmpt.js